import axios from 'axios';

const API_HOST = process.env.REACT_APP_API_HOST;

async function getNotificationsPaginated(params: {
  page?: number;
  limit?: number;
  type?: string;
  read?: string;
}) {
  const { data } = await axios.get(`${API_HOST}/v1/notification/paginated`, {
    params,
  });
  return data;
}

async function getUnreadCount() {
  const { data } = await axios.get(`${API_HOST}/v1/notification/unread-count`);
  return data;
}

async function markAsRead(id: string) {
  const { data } = await axios.patch(`${API_HOST}/v1/notification/${id}/read`);
  return data;
}

async function markAllAsRead() {
  const { data } = await axios.patch(`${API_HOST}/v1/notification/read-all`);
  return data;
}

const notificationsApi = {
  getNotificationsPaginated,
  getUnreadCount,
  markAsRead,
  markAllAsRead,
};

export default notificationsApi;
